import memoize from 'mz-utils/memoize'
import { createBrowserHistory } from 'history'

export const createHistory = memoize(() => {
  return createBrowserHistory()
})

export const getHistory = createHistory
